import React from "react";
import Input from "@/common/components/custom/Input";
import SelectInput from "@/common/components/custom/SelectInput";
import CustomEditButton from "@/common/components/custom/buttons/CustomEditButton";
import { ButtonWrapper } from "../../../AdminCommandPage.styled";
import { DELIMITER_OPTIONS, WIZARD_STEP } from "../constants";
import { Hint } from "../AddLanguageWizard.styled";
import TargetLanguageLabel from "./TargetLanguageLabel";

const StepImportDatabase = ({
  targetLanguage,
  csvFileRef,
  selectedDelimiter,
  setSelectedDelimiter,
  setStep,
  handleImportDatabase,
}) => (
  <>
    <TargetLanguageLabel language={targetLanguage} />
    <Hint>Upload the translated CSV (same format as import_en_xx.csv).</Hint>
    <Input
      inputRef={csvFileRef}
      name="CSV file"
      width={180}
      type="file"
      accept=".csv"
    />
    <SelectInput
      width={180}
      selectWidth={260}
      name="Delimiter"
      options={DELIMITER_OPTIONS}
      selected={selectedDelimiter}
      setSelected={setSelectedDelimiter}
    />
    <ButtonWrapper>
      <CustomEditButton
        text="Back"
        onClick={() => setStep(WIZARD_STEP.COPY_LESSONS)}
      />
      <CustomEditButton text="Import database" onClick={handleImportDatabase} />
      <CustomEditButton
        text="Next"
        onClick={() => setStep(WIZARD_STEP.MARK_WORDS)}
      />
    </ButtonWrapper>
  </>
);

export default StepImportDatabase;
